import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Container = styled.div`
  background: #DEDEDE;
  border-bottom: 2px solid #fff;
  height: 70px;
  &.fixed {
    position: fixed;
    top: 76px;
    left: 0;
    right: 0;
    z-index: 4;
    overflow: hidden;
  }
  a {
    border: 0;
    background: none;
    border-left: 2px solid #fff;
    display: flex;
    height: 100%;
    width: 100%;
    padding: 0 20px;
    text-align: center;
    align-items: center;
    justify-content: center;
    font: 600 16px Montserrat;
    color: #40403F;
    text-decoration: none;
    border-bottom: 4px solid transparent;
    transition: all 0.3s;
    &:last-child {
      border-right: 2px solid #fff;
    }
    @media (min-width: 540px) {
      &:hover {
        background: #fff;
      }
    }
  }
  @media (max-width: 789px) {
    display: none;
  }
`

const slugify = (string) => {
  const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
  const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
  const p = new RegExp(a.split('').join('|'), 'g')

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

class Bar extends Component {
  state = {
    fixed: false,
  }

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = (event) => {
    if ((document.body.clientWidth > 789 && window.scrollY > 182)) {
      this.setState({fixed: true});
      document.querySelector("body").classList.add('bar-fixed')
    } else {
      this.setState({fixed: false});
      document.querySelector("body").classList.remove('bar-fixed')
    }
  };

  render () {
    const { items, tipo } = this.props;
    return (
      <Container id="bar-certificates" className={ this.state.fixed ? 'fixed' : '' }>
        <div className="wrapper flex">
          {
            items && items.map((item, index) => {
              return (
                <Link to={ `/certificados/${tipo}/${slugify(item.nome[0].text)}`} key={ index }>
                  { item.nome[0].text }
                </Link>
              )
            })
          }
        </div>
      </Container>
    )
  }
}

export default Bar;
